<app-page-frame frameTitle="Content Library" titleIcon="bi-book-half" homeRoute="/content-library">
  <router-outlet></router-outlet>
</app-page-frame>
